<template>
  <button :title="data_title" class="btnCustom btnCustom-md btnCustom__outline btnCustom__neutral">
    {{ data_name }}
  </button>
</template>

<script>
export default {
  name: 'ResetButton',
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  data: function () {
    return {
      data_title: this.$t('reset'),
      data_name: this.$t('reset'),
    };
  },
  mounted: function () {
    this.setData();
  },
  methods: {
    setData: function () {
      if (this.title !== undefined && this.title !== null) this.data_title = this.title;
      if (this.name !== undefined && this.name !== null) this.data_name = this.name;
    },
  },
};
</script>

<style scoped></style>
